import React, { useState, useEffect } from "react";
import api from "../../api/api";
import TransferList from "../TransferList";
import { useForm } from "react-hook-form";

const Edit = ({ setCards, item, setWarning, handleOpenSnackbar }) => {
  const [allProducts, setAllProducts] = useState([]);
  const [selectedProducts, setSelectedProducts] = useState([]);
  const {
    register,
    handleSubmit,
    watch,
    formState: { errors },
  } = useForm({
    defaultValues: item,
  });

  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const res = await api.get("/products?take=300");
        const fetchedProducts = res.data.products;
        const initialSelectedProducts = item?.products || [];

        setSelectedProducts(initialSelectedProducts);

        const filteredProducts = fetchedProducts.filter(
          (product) =>
            !initialSelectedProducts.some(
              (selected) => selected.id === product.id
            )
        );

        setAllProducts(filteredProducts);
      } catch (error) {
        console.error("Erro ao buscar produtos:", error);
        setWarning({
          type: "error",
          message: "Falha ao carregar produtos!",
        });
        handleOpenSnackbar();
      }
    };

    fetchProducts();
  }, []);

  const onSubmit = (formData) => {
    const payload = {
      ...formData,
      productIDs: selectedProducts.map((product) => product.id),
    };

    api
      .post("/products/featured", payload)
      .then((response) => {
        if (response.status === 200 || response.status === 201) {
          setWarning({
            type: "success",
            message: "Destaque editado com sucesso!",
          });
          handleOpenSnackbar();
          setCards("");
        } else {
          setWarning({
            type: "warning",
            message:
              "Destaque editado, mas com respostas inesperadas do servidor.",
          });
          handleOpenSnackbar();
          setCards("");
        }
      })
      .catch((error) => {
        let errorMessage = "Falha ao editar o destaque no servidor!";

        if (error.response) {
          errorMessage += ` Detalhes: ${
            error.response.data.message || error.response.status
          }`;
        } else if (error.request) {
          errorMessage = "O servidor não respondeu ao pedido.";
        } else {
          errorMessage = "Erro ao enviar o pedido para o servidor.";
        }

        setWarning({
          type: "error",
          message: errorMessage,
        });
        handleOpenSnackbar();
      });
  };

  return (
    <div className="max-w-7xl mx-auto p-6">
      <div className="mb-8">
        <h1 className="text-3xl font-bold text-gray-800 mb-2">
          Editar Destaque
        </h1>
        <p className="text-gray-600">
          Modifique as configurações do destaque existente
        </p>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
        {/* Formulário - Lado Esquerdo */}
        <div className="lg:col-span-2">
          <form onSubmit={handleSubmit(onSubmit)} className="space-y-6">
            <div className="bg-white border border-gray-200 rounded-lg p-6">
              <h3 className="text-lg font-semibold text-gray-800 mb-4">
                Configurações Básicas
              </h3>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div>
                  <label
                    htmlFor="position"
                    className="block text-sm font-medium text-gray-700 mb-2"
                  >
                    Posição *
                  </label>
                  <select
                    {...register("position", {
                      required: "Selecione uma posição",
                    })}
                    className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors"
                  >
                    <option value="">Selecione uma opção</option>
                    <option value="TOP">TOPO</option>
                    <option value="MID">MEIO</option>
                    <option value="REVIEW">DESTAQUES</option>
                    <option value="BOTTOM">RODAPE</option>
                    <option value="CHECKOUT">CARRINHO</option>
                    <option value="OF_THE_MOMENT">DO MOMENTO</option>
                  </select>
                  {errors.position && (
                    <p className="mt-1 text-sm text-red-600">
                      {errors.position.message || "Este campo é obrigatório"}
                    </p>
                  )}
                </div>

                <div>
                  <label
                    htmlFor="type"
                    className="block text-sm font-medium text-gray-700 mb-2"
                  >
                    Tipo *
                  </label>
                  <select
                    {...register("type", { required: "Selecione um tipo" })}
                    className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors"
                  >
                    <option value="">Selecione uma opção</option>
                    <option value="FOR_YOU">Para você</option>
                    <option value="FOR_BUSINESS">Para salão</option>
                  </select>
                  {errors.type && (
                    <p className="mt-1 text-sm text-red-600">
                      {errors.type.message || "Este campo é obrigatório"}
                    </p>
                  )}
                </div>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-6">
                <div>
                  <label
                    htmlFor="title"
                    className="block text-sm font-medium text-gray-700 mb-2"
                  >
                    Título *
                  </label>
                  <input
                    {...register("title", { required: "Título é obrigatório" })}
                    type="text"
                    className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors"
                    placeholder="Digite o título do destaque"
                  />
                  {errors.title && (
                    <p className="mt-1 text-sm text-red-600">
                      {errors.title.message || "Este campo é obrigatório"}
                    </p>
                  )}
                </div>

                <div>
                  <label
                    htmlFor="href"
                    className="block text-sm font-medium text-gray-700 mb-2"
                  >
                    {watch("position") === "OF_THE_MOMENT"
                      ? "Link do video do YouTube"
                      : "Link (Opcional)"}
                  </label>
                  <input
                    {...register("href")}
                    type="text"
                    className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors"
                    placeholder={
                      watch("position") === "OF_THE_MOMENT"
                        ? "Digite o link do video do YouTube"
                        : "Digite o link do destaque"
                    }
                  />
                </div>
              </div>
            </div>

            <div className="bg-white border border-gray-200 rounded-lg p-6">
              <h3 className="text-lg font-semibold text-gray-800 mb-4">
                Seleção de Produtos
              </h3>

              <div className="mb-4">
                <div className="flex items-center justify-between mb-2">
                  <p className="text-sm text-gray-600">
                    Produtos selecionados:{" "}
                    <span className="font-medium text-blue-600">
                      {selectedProducts.length}
                    </span>
                  </p>
                  <span className="text-xs text-gray-500 bg-gray-100 px-2 py-1 rounded">
                    {watch("position") === "OF_THE_MOMENT"
                      ? "Máximo: 2 produtos"
                      : "Máximo: 4 produtos"}
                  </span>
                </div>
              </div>

              <TransferList
                items={allProducts}
                selectedItems={selectedProducts}
                setSelectedProducts={setSelectedProducts}
                setAllProducts={setAllProducts}
                maxProducts={watch("position") === "OF_THE_MOMENT" ? 2 : 4}
              />
            </div>

            <div className="flex gap-4 pt-6">
              <button
                type="button"
                onClick={() => setCards("")}
                className="px-6 py-3 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition-colors"
              >
                Cancelar
              </button>
              <button
                type="submit"
                className="px-6 py-3 bg-blue-500 text-white rounded-lg hover:bg-blue-700 transition-colors"
              >
                Salvar Alterações
              </button>
            </div>
          </form>
        </div>

        {/* Caixa de Alerta - Lado Direito */}
        <div className="lg:col-span-1">
          <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-6 sticky top-6">
            <h2 className="text-xl font-semibold text-yellow-800 mb-3">
              Informações Importantes
            </h2>
            <div className="space-y-3">
              <div className="flex items-start gap-3">
                <div className="w-2 h-2 bg-yellow-500 rounded-full mt-2 flex-shrink-0"></div>
                <p className="text-yellow-700">
                  <strong>Limite:</strong> Máximo de 2 produtos para a posição
                  "DO MOMENTO" e 4 produtos para as outras posições.
                </p>
              </div>
              <div className="flex items-start gap-3">
                <div className="w-2 h-2 bg-yellow-500 rounded-full mt-2 flex-shrink-0"></div>
                <p className="text-yellow-700">
                  <strong>Verificação:</strong> Confirme cuidadosamente o nome
                  dos produtos selecionados.
                </p>
              </div>
              <div className="flex items-start gap-3">
                <div className="w-2 h-2 bg-yellow-500 rounded-full mt-2 flex-shrink-0"></div>
                <p className="text-yellow-700">
                  <strong>Posição:</strong> Escolha onde o destaque será exibido
                  na página.
                </p>
              </div>
              <div className="flex items-start gap-3">
                <div className="w-2 h-2 bg-yellow-500 rounded-full mt-2 flex-shrink-0"></div>
                <p className="text-yellow-700">
                  <strong>Video:</strong> Ao escolher a posição "DO MOMENTO",
                  deverá adicionar o link do video do YouTube a ser reproduzido
                  na seção. Para outras posições, não é necessário adicionar o
                  link do video.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Edit;
